import { useEffect } from "react";

/**
 * Freezes the platform's brand hue at the Night Blue base (192°).
 *
 * Previously this hook animated `--brand-hue` between blue and teal-green
 * as the visitor scrolled. The palette pivot to the Sand Tan / Night Blue
 * scheme locks the hue in place so buttons, glows and rings stay coherent
 * with the fixed brand system. Kept as a hook so callers don't have to
 * change; delete on next cleanup pass.
 */
const FIXED_HUE = 192;

export default function useScrollHue() {
  useEffect(() => {
    document.documentElement.style.setProperty("--brand-hue", `${FIXED_HUE}`);
  }, []);
}
